import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { useMST3020_R01Store } from "./Store_MST3020_R01";



export const SearchSection_MST3020_R01 = () => {

  const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();
  const { MST3020_R01Filter, setMST3020_R01Filter } = useMST3020_R01Store();

  return (
	<SearchSectionForm>
		<SearchDropDownForm
			label="브랜드"
			value={MST3020_R01Filter.brandCd}
			optionList={brandCdList}
			// onChangeItem prop 사용, setBrandCd는 SysCodeDto를 받음
			onChangeItem={(selectedItem) => setMST3020_R01Filter({ brandCd: selectedItem?.minorCd || ''})}	
		/>
		<SearchDropDownForm
			label="품목그룹"
			value={MST3020_R01Filter.itemGroup}
			optionList={itemGroupList}
			onChangeItem={(selectedItem) => setMST3020_R01Filter({ itemGroup: selectedItem?.minorCd || ''})}
		/>
		<SearchDropDownForm
			label="품목계정"
			value={MST3020_R01Filter.itemAccount}
			optionList={itemAccountList}
			onChangeItem={(selectedItem) => setMST3020_R01Filter({ itemAccount: selectedItem?.minorCd || ''})}
		/>
	</SearchSectionForm>
  )
}